import {
  Directive,
  HostBinding,
  HostListener,
  Inject,
  Optional,
  NgZone,
  OnInit,
  ElementRef,
  ViewContainerRef,
  AfterViewInit,
} from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY,
  MatTooltip,
  MatTooltipDefaultOptions,
} from '@angular/material/tooltip';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher, ScrollStrategy } from '@angular/cdk/overlay';
import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Platform } from '@angular/cdk/platform';

@Directive({ selector: '[cropToggleLabel]' })
export class CropToggleLabelDirective extends MatTooltip implements OnInit, AfterViewInit {
  @HostBinding('class') elementClass: string;

  @HostListener('mouseenter') onMouseenter(): void {
    const textElement = this.elementRef.nativeElement.querySelector('label');
    if (textElement?.scrollWidth > textElement.clientWidth) {
      this.message = textElement.innerText;
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseleave(): void {
    this.hide();
  }

  constructor(
    overlay: Overlay,
    scrollDispatcher: ScrollDispatcher,
    viewContainerRef: ViewContainerRef,
    ngZone: NgZone,
    platform: Platform,
    ariaDescriber: AriaDescriber,
    focusMonitor: FocusMonitor,
    @Optional() dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY)
    scrollStrategy: ScrollStrategy,
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    defaultOptions: MatTooltipDefaultOptions,
    private elementRef: ElementRef,
  ) {
    super(
      overlay,
      elementRef,
      scrollDispatcher,
      viewContainerRef,
      ngZone,
      platform,
      ariaDescriber,
      focusMonitor,
      scrollStrategy,
      dir,
      defaultOptions,
      {},
    );
  }

  ngOnInit(): void {
    this.elementClass = 'cropped';
    this.elementRef.nativeElement.querySelector('label').style.width = '100%';
  }

  // overwriting ngAfterViewInit() to prevent unnecessary logic from super class
  // eslint-disable-next-line
  ngAfterViewInit(): void {}
}
